import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

/**
 * The initial page size is small to avoid SSR timeouts
 * @see https://softwareteams.atlassian.net/browse/RLSS-3256
 */
export const NON_WARNINGS_TABLE_INITIAL_PAGE_SIZE = 20;
export const NON_WARNINGS_TABLE_PAGE_SIZE = 50;
export const WARNINGS_TABLE_PAGE_SIZE = 10;
export const MAX_BADGE_TOTAL = 1000;
export const HEADER_LEFT_CONTAINER_WIDTH = gridSize * 100;
export const STATUS_LOZENGE_WIDTH = gridSize * 12;

// RLSS-2812 Replace color.background.neutral to color.background.accent.gray.subtlest
export const ALL_SEGMENT_COLOR = token('color.background.neutral', colors.N30);

export const TODO_SEGMENT_COLOR = token('color.background.neutral', colors.N30);
export const TODO_SEGMENT_COLOR_HIGHER_CONTRAST = token('color.border', colors.N30);

export const IN_PROGRESS_SEGMENT_COLOR = token('color.background.information.bold', colors.B400);
export const IN_PROGRESS_SEGMENT_COLOR_HIGHER_CONTRAST = token(
	'color.border.information',
	colors.B200,
);

export const DONE_SEGMENT_COLOR = token('color.background.success.bold', colors.G300);
export const DONE_SEGMENT_COLOR_HIGHER_CONTRAST = token('color.border.success', colors.G300);

export const OPEN = 'OPEN' as const;
export const DECLINED = 'DECLINED' as const;
export const MERGED = 'MERGED' as const;

export const RELATED_WORK_CATEGORY_MORE_THRESHOLD = 5;
export const RELATED_WORK_SHOW_MORE_THRESHOLD = 5;

export const ARCHIVED = 'ARCHIVED' as const;

export const SIDEBAR_RESIZE_BUTTON_SELECTOR = 'VersionDetailsRightSidebarResizeButton';
